import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, LogIn, Car } from "lucide-react";
import api from "@/lib/api";
import { useSite, waLink } from "@/lib/siteDil";
import { WaIkon } from "@/pages/site/SiteLayout";
import { Fiyat, Gorsel, UrunKarti } from "@/components/site/SiteParca";

const yil = (a) => (a.yil_bas || a.yil_bit ? `${a.yil_bas || ""}–${a.yil_bit || ""}` : "");

export default function SiteUrunDetay() {
  const { kod } = useParams();
  const { t, lang, yol, ic, setWaUrun } = useSite();
  const [u, setU] = useState(undefined);
  useEffect(() => { setWaUrun(u ? { ad: u.ad, kod: u.kod } : null); }, [u, setWaUrun]);
  useEffect(() => () => { setWaUrun(null); }, [setWaUrun]);
  const wa = ic?.genel.whatsapp?.replace(/\D/g, "");
  useEffect(() => {
    setU(undefined);
    api.get(`/site/urun/${encodeURIComponent(kod)}`, { params: { lang } }).then((r) => setU(r.data)).catch(() => setU(null));
    window.scrollTo({ top: 0 });
  }, [kod, lang]);
  if (u === undefined) return <div className="max-w-7xl mx-auto px-6 py-24 text-slate-400">…</div>;
  if (u === null) return <div className="max-w-7xl mx-auto px-6 py-24 space-y-4" data-testid="site-urun-yok"><h1 className="text-3xl font-extrabold">{t.bulunamadi}</h1><Link to={yol("/urunler")} className="text-[var(--s-primary)] font-semibold">{t.geri}</Link></div>;
  const ozellik = [[t.kod, u.kod], [t.olcu, u.olcu], [t.oem, u.oem_no], [t.sicaklik, u.sicaklik], [t.urunGruplari, [u.grup, u.marka].filter(Boolean).join(" › ")]].filter(([, v]) => v);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 space-y-16" data-testid="site-urun-detay">
      <div className="space-y-6">
        <Link to={yol("/urunler")} className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900" data-testid="site-geri"><ArrowLeft className="w-4 h-4 rtl:rotate-180" />{t.geri}</Link>
        <div className="grid lg:grid-cols-2 gap-10">
          <div className="border border-slate-200 rounded-md overflow-hidden"><Gorsel u={u} className="w-full h-80 sm:h-[420px] p-6" /></div>
          <div className="space-y-6">
            <div className="space-y-2">
              <span className="font-mono text-sm text-[var(--s-primary)] font-semibold" dir="ltr" data-testid="site-detay-kod">{u.kod}</span>
              <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 leading-tight" data-testid="site-detay-ad">{u.ad}</h1>
            </div>
            <div className="bg-[var(--s-surface)] border border-slate-200 rounded-md p-5 space-y-4">
              <Fiyat u={u} buyuk />
              <a href="/bayi" data-testid="site-detay-bayi" className="flex items-center justify-center gap-2 h-12 rounded-sm bg-[var(--s-primary)] hover:bg-[var(--s-primary-h)] text-white font-semibold transition-colors"><LogIn className="w-4 h-4 rtl:rotate-180" />{t.bayiFiyat}</a>
              {wa && <a href={waLink(wa, t.waUrun(u.ad, u.kod))} target="_blank" rel="noopener noreferrer" data-testid="site-detay-whatsapp" className="flex items-center justify-center gap-2 h-12 rounded-sm bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold transition-colors"><WaIkon className="w-5 h-5" />{t.waSor}</a>}
            </div>
            <dl className="divide-y divide-slate-200 border-y border-slate-200" data-testid="site-detay-ozellik">
              {ozellik.map(([k, v]) => <div key={k} className="flex justify-between gap-4 py-3 text-sm"><dt className="text-slate-500">{k}</dt><dd className="font-medium text-slate-900 text-end" dir="auto">{v}</dd></div>)}
            </dl>
            {u.araclar?.length > 0 && (
              <div className="space-y-3" data-testid="site-detay-araclar">
                <h2 className="text-base md:text-lg font-bold text-slate-900">{t.uyumluAraclar}</h2>
                <div className="flex flex-wrap gap-2">{u.araclar.map((a, i) => <span key={i} className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-sm bg-slate-100 text-slate-800"><Car className="w-3.5 h-3.5" />{[a.marka, a.model, yil(a), a.motor].filter(Boolean).join(" ")}</span>)}</div>
              </div>
            )}
            {u.aciklama && <p className="text-sm text-slate-600 whitespace-pre-line">{u.aciklama}</p>}
          </div>
        </div>
      </div>
      {u.benzer?.length > 0 && (
        <section className="space-y-6"><h2 className="text-xl sm:text-2xl font-extrabold text-slate-900">{t.benzer}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">{u.benzer.map((x, i) => <UrunKarti key={x.id} u={x} i={i} />)}</div></section>
      )}
    </div>
  );
}
